import { useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { RouteEnum } from '../constantes/RouteEnum';
import { UserSearchResponse } from '../_types/user.types';
import { useSchema } from './useSchema';
import { useOtpContext } from '../context/OtpContextProvider';

export const useNavigationFlow = () => {
  const navigate = useNavigate();
  const {checkIsOpenFlow, getAuthenticationType} = useSchema();
  const {setCurrentFlow} = useOtpContext();

  const navigateToLogin = useCallback((authenticationType: string) => {
    const route = authenticationType === 'otp'
      ? RouteEnum.OTP_REQUEST
      : RouteEnum.LOGIN_PASSWORD;
    navigate(route);
  }, [navigate]);

  const navigateBasedOnUserData = useCallback((userData: UserSearchResponse) => {
    const isOpenFlow = checkIsOpenFlow();
    const isFirstAccess = userData?.firstAccess;
    const isOnboardingFinished = userData?.onboardingFinished;
    const userFound = userData?.userFound;

    console.log('Navigation Flow - userData:', userData);
    console.log('Navigation Flow - isOpenFlow:', isOpenFlow);
    console.log('Navigation Flow - isFirstAccess:', isFirstAccess);
    console.log('Navigation Flow - isOnboardingFinished:', isOnboardingFinished);
    console.log('Navigation Flow - userFound:', userFound);

    // CASO 0: Usuário não encontrado
    if (!userFound) {
      if (isOpenFlow) {
        navigate(RouteEnum.PERSONAL);
      } else {
        console.error('Usuário não encontrado em fluxo fechado');
      }

      return;
    }

    // CASO 1: Fluxo Open - onboarding não finalizado (independente de primeiro acesso)
    if (isOpenFlow && !isOnboardingFinished) {
      console.log('Navegando para OTP_REQUEST - Fluxo Open, onboarding não finalizado');
      navigate(RouteEnum.OTP_REQUEST);

      return;
    }

    // CASO 2: Fluxo Open - onboarding finalizado
    if (isOpenFlow && isOnboardingFinished) {
      console.log('Navegando para login - Fluxo Open, onboarding finalizado');
      navigateToLogin(getAuthenticationType());

      return;
    }

    // CASO 3: Fluxo Close - primeiro acesso e onboarding não finalizado
    if (!isOpenFlow && isFirstAccess && !isOnboardingFinished) {
      console.log('Navegando para OTP_REQUEST - Fluxo Close, primeiro acesso');
      navigate(RouteEnum.OTP_REQUEST);

      return;
    }

    // CASO 4: Fluxo Close - não é primeiro acesso mas onboarding não finalizado
    if (!isOpenFlow && !isFirstAccess && !isOnboardingFinished) {
      console.log('Navegando para OTP_REQUEST - Fluxo Close, não primeiro acesso');
      navigate(RouteEnum.OTP_REQUEST);

      return;
    }

    // CASO 5: Caso padrão (onboarding finalizado)
    console.log('Navegando para login - Caso padrão');
    navigateToLogin(getAuthenticationType());
  }, [navigate, checkIsOpenFlow, getAuthenticationType]);

  const navigateToRegister = useCallback(() => {
    navigate(RouteEnum.PERSONAL);
  }, [navigate]);

  const navigateToWelcome = useCallback(() => {
    navigate(RouteEnum.WELCOME);
  }, [navigate]);

  const navigateToUserLogin = useCallback(() => {
    navigate(RouteEnum.LOGIN_USERNAME);
  }, [navigate]);

  const navigateToPasswordReset = useCallback(() => {
    // Configurar o contexto para ResetPassword
    setCurrentFlow('ResetPassword');
    navigate(RouteEnum.FORGOT_PASSWORD_OTP_REQUEST);
  }, [navigate, setCurrentFlow]);

  const navigateToOtpValidation = useCallback(() => {
    navigate(RouteEnum.OTP_VALIDATION);
  }, [navigate]);

  const navigateToFinish = useCallback(() => {
    navigate(RouteEnum.FINISH);
  }, [navigate]);

  return {
    navigateBasedOnUserData,
    navigateToRegister,
    navigateToWelcome,
    navigateToUserLogin,
    navigateToPasswordReset,
    navigateToOtpValidation,
    navigateToFinish,
    navigateToLogin
  };
};
 